"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsDeprecated_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var AffilatePromoCodesTemplatesList = /** @class */ (function (_super) {
    __extends(AffilatePromoCodesTemplatesList, _super);
    function AffilatePromoCodesTemplatesList(props) {
        return _super.call(this, props) || this;
    }
    AffilatePromoCodesTemplatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    AffilatePromoCodesTemplatesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    AffilatePromoCodesTemplatesList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.DoSetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    AffilatePromoCodesTemplatesList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'П.Программа',
                dataIndex: this.props.data.dk_brand_id,
                key: this.props.data.dk_brand_id,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.title));
                },
            }, {
                title: 'Макс кол-во',
                dataIndex: this.props.data.dk_max_promo_count,
                key: this.props.data.dk_max_promo_count,
                width: 150,
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Тип промокода',
                dataIndex: this.props.data.dk_promocode_template_type_title,
                key: this.props.data.dk_promocode_template_type_title,
                width: 150,
            }, {
                title: 'Шаблон промокода',
                dataIndex: this.props.data.dk_promocode_template_title,
                key: this.props.data.dk_promocode_template_title,
                width: 150,
            }, {
                title: 'Описание промокода',
                dataIndex: this.props.data.dk_promocode_template_description,
                key: this.props.data.dk_promocode_template_description,
                width: 150,
            }, {
                title: 'Устаревший',
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.promocode_template_title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }
        ]);
    };
    AffilatePromoCodesTemplatesList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    AffilatePromoCodesTemplatesList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0428\u0430\u0431\u043B\u043E\u043D \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.promocode_template_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    AffilatePromoCodesTemplatesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    AffilatePromoCodesTemplatesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return AffilatePromoCodesTemplatesList;
}(React.Component));
exports.default = AffilatePromoCodesTemplatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/promo_codes_templates/AffilatePromoCodesTemplatesList.tsx
// module id = 2028
// module chunks = 0